import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Redirect from "./pages/Redirect";

function App() {
  return (
    <Router>
      <Routes>
        {/* Redirect page (subdomain → root) */}
        <Route path="/" element={<Redirect />} />

        {/* Fallback 404 */}
        <Route path="*" element={<Redirect />} />
      </Routes>
    </Router>
  );
}

export default App;
